exports.ERROR_MSGES = {
    DAY_OF_WEEK_ERROR_MSG_1: 'Day-of-Week values must be between 1 and 7',
    DAY_OF_WEEK_ERROR_MSG_2: 'Day-of-Week values must be SUN, MON, TUE, WED, THU, FRI, SAT OR between 1 and 7, - * ? / L #',
    DAY_OF_WEEK_ERROR_MSG_3: '(Day of week) - Unsupported value for field. Possible values are 1-7 or SUN-SAT , - * ? / L #',
    DAY_OF_WEEK_ERROR_MSG_4: 'A numeric value between 1 and 5 must follow the # option',
    
    DAY_OF_MONTH_ERROR_MSG_1: 'Day of month values must be between 1 and 31',
    DAY_OF_MONTH_ERROR_MSG_2: 'Offset from last day must be <= 30',

    MONTH_ERROR_MSG: 'Month values must be between 1 and 12',
    MONTH_LETTER_ERROR_MSG: 'Month values must be JAN, FEB, MAR, APR, MAY, JUN, JUL, AUG, SEP, OCT, NOV, DEC OR between 1 and 12',

    YEAR_ERROR_MSG: 'Start year must be less than stop year',
    YEAR_UNSUPPORT_VAL_ERROR_MSG: '(Year) - Unsupported value for field. Possible values are 1970-2099 , - * /',

    TIME_ERROR_MSG: 'Minute and Second values must be between 0 and 59 and Hour Values must be between 0 and 23',

    DAY_OF_MONTH_DAY_OF_WEEK_ERROR_MSG: '? can only be specfied for Day-of-Month -OR- Day-of-Week',

    UNEXPECTED_ERROR_MSG: 'Unexpected end of expression',
}